module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="albumOperation"><div class="albumOperationImage"><img src="images/corner_add.png"/></div><div class="albumOperationTitle">Ajouter un album</div></div>\n<div class="albumOperation"><div class="albumOperationImage"><img src="images/corner_add.png"/></div><div class="albumOperationTitle">Ajouter une photo</div></div>';

}
return __p
}